import React from 'react';
import './Header.css'
import { Link } from "react-router-dom";
function Header() {
  return (
    <div className='header'>

      <Link to="/"> <div className='header-left'>

        <img className='header-left-img' src='https://i.pinimg.com/originals/47/b7/bd/47b7bdac4285ee24654ca7d68cf06351.png' />
      </div></Link>
      <div className='location-logo'>

        <img className='header-left-img-logo-1' src='https://www.citypng.com/public/uploads/preview/transparent-address-location-map-white-icon-symbol-11640206702y0mv170ixx.png' />

      </div>
      <div className='location-txt'>
        <p1 className='hello' >Hello</p1>
        <h3>select your adress</h3>
      </div>

      <div className='searchbar-full'>
        <div className='list-left'> ALL </div>
        <div className='search-centre'><input className='search-centre-input' placeholder='Search amazon.ca'></input></div>
        <div className='magnifier-right'><img className='magnifier-right-img' src='https://img.uxwing.com/wp-content/themes/uxwing/download/user-interface/search-icon.png' /></div>
      </div>

      <div className='right-text-box'>
        
        <div className='country-ln'>
          <img className='country-flag' src='https://upload.wikimedia.org/wikipedia/en/thumb/c/cf/Flag_of_Canada.svg/2560px-Flag_of_Canada.svg.png' />
          <h3 style={{ marginTop: "0.3rem" }} >EN</h3>
        </div>

        <div className='sign-in-txt'><h5>Hello, sign in</h5> <h4>Account & List</h4></div>


        <div className='return-order'><h5>Returns</h5> <h4>& Orders</h4></div>
        
        <Link to='/Checkout'>  
        <div className='cart-logo'><img className='cart-logo-img' src='https://d2gg9evh47fn9z.cloudfront.net/800px_COLOURBOX5559874.jpg' />  <h4 className='cart-txt'> Cart </h4></div>
        </Link>


      </div>
      <div className='bottom-header'>
        <h6 className='link-header'>All</h6>
        <h6 className='link-header'>Prime</h6>
        <h6 className='link-header'>Home</h6>
        <h6 className='link-header'>Books</h6>
        <h6 className='link-header'>Electronics</h6>
        <h6 className='link-header'>Kindle</h6>

        <h6 className='link-header'>New&nbsp;Realease</h6>
        <h6 className='link-header'>Best&nbsp;Seller</h6>
        <h6 className='link-header'>Deal&nbsp;Store</h6>
        <h6 className='link-header'>Customer&nbsp;Service</h6>
        <h6 className='link-header'>Sports&nbsp;&&nbsp;Outdoors</h6>





      </div>
    </div>

  )
}

export default Header;